import { effect, inject, Injectable, signal } from '@angular/core';
import {
  NavSlimService,
  NavSlimVacationSearchContent
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { VacationHeaderAdapter } from '../../../adapters/vacation-header/vacation-header.adapter';

@Injectable({ providedIn: 'root' })
export class VacationHeaderFacadeService {
  private adapter = inject(VacationHeaderAdapter);
  private navSlimService = inject(NavSlimService);

  vacationSearchContent = signal<NavSlimVacationSearchContent | undefined>(
    undefined
  );

  constructor() {
    effect(
      () => {
        const data = this.navSlimService.updateVacationData();
        if (data) {
          const transformData = this.adapter.transformFromInput(data);
          this.vacationSearchContent.set(
            this.adapter.toVacationSearchContent(transformData)
          );
        }
      },
      { allowSignalWrites: true }
    );
  }
}
